const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const getLocalDateString = (date: Date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const validateGroupId = (id: string | null): string | undefined =>
  id && UUID_REGEX.test(id) ? id : undefined;

export const validateMealId = validateGroupId;

export const formatHomeSelectedDate = (selectedDate: string) =>
  new Date(`${selectedDate}T00:00:00`).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

export const getSuggestedMealContext = () => {
  const hour = new Date().getHours();
  if (hour < 11) {
    return { meal: "Breakfast", chip: "Breakfast window", peakHint: "167" };
  }
  if (hour < 15) {
    return { meal: "Lunch", chip: "Lunch is usually highest", peakHint: "167" };
  }
  if (hour < 18) {
    return { meal: "Snack", chip: "Afternoon snack", peakHint: "155" };
  }
  return { meal: "Dinner", chip: "Evening log", peakHint: "160" };
};

export const getDaysInMonth = (date: Date) => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const daysInMonth = lastDay.getDate();
  const startingDayOfWeek = firstDay.getDay();
  const days: (Date | null)[] = [];

  for (let i = 0; i < startingDayOfWeek; i++) {
    days.push(null);
  }
  for (let day = 1; day <= daysInMonth; day++) {
    days.push(new Date(year, month, day));
  }
  return days;
};

export const shiftCalendarMonth = (prev: Date, direction: "prev" | "next") => {
  const newMonth = new Date(prev);
  if (direction === "prev") {
    newMonth.setMonth(prev.getMonth() - 1);
  } else {
    newMonth.setMonth(prev.getMonth() + 1);
  }
  return newMonth;
};

export const isFutureDateString = (dateString: string) => {
  const selectedDateObj = new Date(`${dateString}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  selectedDateObj.setHours(0, 0, 0, 0);
  return selectedDateObj > today;
};
